import ApiPage from 'pages/ApiPage/ApiPage';
import ContactPage from 'pages/Contact/Contact';
import DefailPage from 'pages/Detail/DetailPage';
import HomePage from 'pages/HomePage/HomePage';
import PartnersPage from 'pages/Partners/Partnerspage';
import React from 'react';
interface RouteItem {
    path: string;
    page: React.FC;
    value: string;
    layout?: 'DEFAULT' | null;
}
const appRoutes: RouteItem[] = [
    {
        path: '/',
        page: HomePage,
        value: 'Home',
    },
    {
        path: '/partners',
        page: PartnersPage,
        value: 'Partners'
    },
    {
        path: '/api',
        page: ApiPage,
        value: 'Api'
    },
    {
        path: '/contact',
        page: ContactPage,
        value: 'Contact'
    },
    {
        path: '/detail',
        page: DefailPage,
        value: 'Detail',
    },
];

export default appRoutes;
